import { auth, useE2EAuth } from "../store/auth";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from "firebase/auth";

export default {
  authenticate(email, password) {
    if (useE2EAuth) return Promise.resolve(setE2EUser(email));

    return signInWithEmailAndPassword(auth, email, password).then(response => {
      return response.user;
    });
  },
  register(email, password, displayName) {
    if (useE2EAuth) return Promise.resolve(setE2EUser(email, displayName));

    return createUserWithEmailAndPassword(auth, email, password).then(async response => {
      await updateProfile(response.user, { displayName });
      await response.user.getIdToken(true);
      return response.user;
    });
  }
};

function setE2EUser(email, displayName) {
  const user = {
    uid: email,
    email,
    displayName: displayName || email,
    emailVerified: true,
    getIdToken: () => Promise.resolve(`e2e:${email}`)
  };

  auth.currentUser = user;
  return user;
}
